import React from 'react'
import PropTypes from 'prop-types'
import flow from 'lodash/flow'
import noop from 'lodash/noop'
import { withRouter } from 'react-router'
import { NavDropdown, MenuItem } from 'react-bootstrap'
import languages from '../../i18n/languages.json'

import { connect } from 'react-redux'
import { changeLanguage } from '../../state/user'

const actionsToProps = dispatch => ({
    changeLanguage: lang => dispatch(changeLanguage(lang))
})

class Language extends React.Component {

  onSelect = (sel) => {
    const selected = sel.split('.')[1]
    if (selected !== this.props.lang) {
      this.props.changeLanguage(selected)
    }
  }

  language = () => {
    const { lang } = this.props
    let name
    languages.forEach(item => {
      if (lang === item.value) name = item.englishName
    })
    return name
  }

  render() {
    return (
      <NavDropdown title={this.language()} id='nav-language' onSelect={this.onSelect}>
        {languages.map(
          (item, i) => <MenuItem key={i} eventKey={'lang.'+item.value}>{item.englishName}</MenuItem>
        )}
      </NavDropdown>
    )
  }
}

Language.defaultProps = {
  lang: 'en',
  changeLanguage: noop,
}

Language.propTypes = {
  lang: PropTypes.string,
  changeLanguage: PropTypes.func
}

const decorators = flow([
  connect(null, actionsToProps),
  withRouter
])

export default decorators(Language)



// WEBPACK FOOTER //
// ./src/components/nav/Language.js